import styled from "styled-components";

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.CONSTANTS.XH * 2.5}px;

  @media (min-width: 1025px) {
    gap: ${({ theme }) => theme.CONSTANTS.XH * 3}px;
  }
`;
